import Vue from 'vue'
import { getAccessorType, actionTree, mutationTree } from 'typed-vuex'
import { SCHOLARSHIP_LIST, APPLICATION_LIST } from '~/store/cardList'
import { ELIGIBLE_SCHOLARSHIP_COUNT, NOT_SEEN_SCHOLARSHIP_COUNT } from '~/store/eligibilityCache'

import * as featureSet from '~/store/featureSet'
import * as account from '~/store/account'
import * as cardList from '~/store/cardList'
import * as screen from '~/store/screen'
import * as sideBar from '~/store/sideBar'
import * as gameStreak from '~/store/gameStreak'
import * as gameLevel from '~/store/gameLevel'
import * as recommendation from '~/store/recommendation'
import * as cardReport from '~/store/cardReport'
import * as filters from '~/store/filters'
import * as categories from '~/store/categories'
import * as applicationReview from '~/store/applicationReview'
import * as sorting from '~/store/sorting'
import * as eligibleSorted from '~/store/eligibleSorted'
import * as details from '~/store/details'
import * as requirements from '~/store/requirements'
import * as statistic from '~/store/statistic'
import * as options from '~/store/options'
import * as mailbox from '~/store/mailbox'
import * as list from '~/store/list'
import * as tabList from '~/store/tabList'
import * as ui from '~/store/ui'
import * as persistent from '~/store/persistent'
import * as applicationStrategy from '~/store/applicationStrategy'
import { EASY_APPLY_TAB } from '~/store/sideBar'

const state = () => ({
  initialized: false,
  skipFetchList: false
})

export const actions = actionTree(
  { state },
  {
    async initStore({ commit, state, rootGetters }, $config): Promise<void> {
      commit('featureSet/setState', { stateName: 'config', data: $config })

      if (!this.$auth.loggedIn) { return }

      const resources = [
        this.app.$accessor.account.setAccount({ resources: ['membership', 'profile', 'mailbox'] }),
        this.app.$accessor.eligibilityCache.getEligibilities([ELIGIBLE_SCHOLARSHIP_COUNT, NOT_SEEN_SCHOLARSHIP_COUNT]),
        this.app.$accessor.account.fetchAutoApplicationSetting()
      ]

      if (!this.state.skipFetchList) {
        resources.push(this.app.$accessor.cardList.fetchList({ storeName: SCHOLARSHIP_LIST }))
        resources.push(this.app.$accessor.cardList.fetchList({ storeName: APPLICATION_LIST }))
        // @ts-expect-error
        this.app.$accessor.recommendation.fetchRecommendedScholarships() // don't block rendering
      }

      await Promise.all(resources)

      commit('tabList/setState', {
        stateName: 'initEasyScholarshipsLength',
        data: rootGetters[`tabList/${EASY_APPLY_TAB}`].length
      })

      this.app.$accessor.account.setPaymentDetails()
        .catch(err => this.$sentry.captureException(err))

      if (this.app.$accessor.featureSet.isGame) {
        await Promise.all([
          this.app.$accessor.gameLevel.setLevel(),
          this.app.$accessor.gameStreak.getStreaks()
        ])
      }

      commit('setInitialized', true)
    },
    fetchListController({ commit }, fullPath): void {
      if (fullPath.includes('scholarships')) {
        commit('setSkipFetchList', false)
      } else {
        commit('setSkipFetchList', true)
      }
    }
  }
)

export const mutations = mutationTree(
  state,
  {
    setInitialized: (state, value) => {
      Vue.set(state, 'initialized', value)
    },
    setSkipFetchList: (state, value) => {
      state.skipFetchList = value
    }
  }
)

// This compiles to nothing and only serves to return the correct type of the accessor
export const accessorType = getAccessorType({
  actions,
  modules: {
    // The key (submodule) needs to match the Nuxt namespace (e.g. ~/store/submodule.ts)
    featureSet,
    account,
    cardList,
    screen,
    sideBar,
    gameStreak,
    gameLevel,
    recommendation,
    cardReport,
    filters,
    categories,
    applicationReview,
    sorting,
    eligibleSorted,
    details,
    requirements,
    mailbox,
    list,
    statistic,
    options,
    tabList,
    ui,
    persistent,
    applicationStrategy
  }
})
